<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
  font-size: 14px !important;
  text-align: right;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.legend-con {
  font-family: "Prompt", sans-serif !important;
  display: inline-block;

  ul {
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    span {
      display: inline-block;
    }

    span.chart-legend {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between mb-2">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        รายงานวางบิล / แจ้งหนี้
      </div>
      <v-spacer></v-spacer>
      <v-btn color="default" @click="export_bill()">
        <v-icon left dark> mdi-printer </v-icon>ดาวน์โหลด
      </v-btn>
      <v-btn class="ml-2" color="primary" @click="linktoAnamai()">
        <v-icon left dark> mdi-share </v-icon>รายงาน
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-row class="mb-n6">
      <v-col cols="12" class="mr-n15">
        <date-picker
          :format="momentFormat"
          type="month"
          v-model="time3"
          class="custom-datepicker mr-5"
        ></date-picker>

        <v-autocomplete
          label="จังหวัด"
          :items="pro_list"
          class="mr-5"
          style="width: 180px; display: inline-block"
          v-model="province"
          solo
        ></v-autocomplete>

        <v-autocomplete
          label="ประเภท"
          :items="[
            'โรงพยาบาลรัฐ',
            'โรงพยาบาลเอกชน',
            'รพ.สต.',
            'แลป',
            'เวชกรรมความงาม',
            'เวชกรรมทั่วไป.',
            'ทันตกรรม',
            'สัตวแพทย์',
            'อื่น ๆ',
          ]"
          class="mr-5"
          style="width: 180px; display: inline-block"
          v-model="cus_type"
          solo
        ></v-autocomplete>
        <v-select
          label="ภาษีมูลค่าเพิ่ม"
          :items="['เสียภาษี', 'ไม่เสียภาษี']"
          class="mr-5"
          style="width: 180px; display: inline-block"
          v-model="isvat"
          solo
        ></v-select>

        <v-btn large color="info" style="width: 80px" @click="search()">
          <v-icon left dark>mdi-magnify</v-icon>ค้นหา
        </v-btn>
        <v-btn
          class="mx-2"
          large
          style="width: 80px"
          color="default"
          @click="clear()"
        >
          <v-icon left dark> mdi-close </v-icon>ล้าง
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-data-table
        :headers="headers"
        :items="getIndex"
        item-key="index"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.index }}</td>
            <td>{{ item.BILL_ID }}</td>
            <td>{{ item.REF_CUS }}</td>

            <td>{{ item.CUSTOMER_GROUP }}</td>
            <td>{{ item.CUSTOMER_NAME }}</td>
            <td>{{ item.WALKOUT_DATE | formatDate }}</td>
            <td>{{ item.TOTAL_WEIGHT | delimeter }}</td>
            <td>{{ item.PAID_NO_VAT | delimeter }}</td>
            <td>{{ item.PAID_VAT-item.PAID_NO_VAT | delimeter }}</td>
            <td>{{ item.VAT3 | delimeter }}</td>
            <td>{{ item.TOTAL_PRICE | delimeter }}</td>
          </tr>
        </template>
        <template slot="body.append">
          <tr>
            <th colspan="2" class="text-h5 font-weight-black primary--text">
              จำนวนรวมทั้งหมด
            </th>

            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="text-h5 font-weight-black primary--text">
              {{ sumField("TOTAL_WEIGHT") | delimeter }}
            </th>
            <th class="text-h5 font-weight-black primary--text">
              {{ sumField("PAID_NO_VAT") | delimeter }}
            </th>
            <th class="text-h5 font-weight-black primary--text">
              {{ sumField("PAID_VAT") | delimeter }}
            </th>
            <th class="text-h5 font-weight-black primary--text">
              {{ sumField("VAT3") | delimeter }}
            </th>
            <th class="text-h5 font-weight-black primary--text">
              {{ sumField("TOTAL_PRICE") | delimeter }}
            </th>
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
import XLSX from "xlsx";
export default {
  components: {},
  name: "BillReport",
  data: () => ({
    time3: new Date(),
    isvat: "เสียภาษี",
    pro_list: [
      "กรุงเทพมหานคร",
      "กระบี่",
      "กาญจนบุรี",
      "กาฬสินธุ์",
      "กำแพงเพชร",
      "ขอนแก่น",
      "จันทบุรี",
      "ฉะเชิงเทรา",
      "ชัยนาท",
      "ชัยภูมิ",
      "ชุมพร",
      "ชลบุรี",
      "เชียงใหม่",
      "เชียงราย",
      "ตรัง",
      "ตราด",
      "ตาก",
      "นครนายก",
      "นครปฐม",
      "นครพนม",
      "นครราชสีมา",
      "นครศรีธรรมราช",
      "นครสวรรค์",
      "นราธิวาส",
      "น่าน",
      "นนทบุรี",
      "บึงกาฬ",
      "บุรีรัมย์",
      "ประจวบคีรีขันธ์",
      "ปทุมธานี",
      "ปราจีนบุรี",
      "ปัตตานี",
      "พะเยา",
      "พระนครศรีอยุธยา",
      "พังงา",
      "พิจิตร",
      "พิษณุโลก",
      "เพชรบุรี",
      "เพชรบูรณ์",
      "แพร่",
      "พัทลุง",
      "ภูเก็ต",
      "มหาสารคาม",
      "มุกดาหาร",
      "แม่ฮ่องสอน",
      "ยโสธร",
      "ยะลา",
      "ร้อยเอ็ด",
      "ระนอง",
      "ระยอง",
      "ราชบุรี",
      "ลพบุรี",
      "ลำปาง",
      "ลำพูน",
      "เลย",
      "ศรีสะเกษ",
      "สกลนคร",
      "สงขลา",
      "สมุทรสาคร",
      "สมุทรปราการ",
      "สมุทรสงคราม",
      "สระแก้ว",
      "สระบุรี",
      "สิงห์บุรี",
      "สุโขทัย",
      "สุพรรณบุรี",
      "สุราษฎร์ธานี",
      "สุรินทร์",
      "สตูล",
      "หนองคาย",
      "หนองบัวลำภู",
      "อำนาจเจริญ",
      "อุดรธานี",
      "อุตรดิตถ์",
      "อุทัยธานี",
      "อุบลราชธานี",
      "อ่างทอง",
    ],
    cus_type: "",
    province: "",
    headers: [
      {
        text: "ลำดับ",
        align: "left",
        sortable: true,
        value: "index",
      },
      {
        text: "รหัสใบวางบิล",
        align: "left",
        sortable: true,
        value: "BILL_ID",
      },
      {
        text: "รหัสอ้างอิง",
        align: "left",
        sortable: true,
        value: "REF_CUS",
      },

      { text: "ประเภท", value: "CONTRACT_CATEGORY", align: "left" },
      { text: "ลูกค้า", value: "CUSTOMER_NAME", align: "left" },
      { text: "วันที่", value: "WALKOUT_DATE", align: "left" },
      { text: "จำนวน (กก.)", value: "TOTAL_WEIGHT", align: "left" },
      { text: "จำนวนเงิน", value: "PAID_NO_VAT", align: "left" },
      { text: "ภาษีมูลค่าเพิ่ม", value: "PAID_VAT", align: "left" },
      { text: "ภาษีหัก ณ ที่จ่าย", value: "VAT3", align: "left" },
      { text: "ยอดสุทธิ", value: "TOTAL_PRICE", align: "left" },
    ],
    table_data: [],
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    now_Date: new Date(),
  }),
  watch: {},
  created() {},
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).add(543, "year").format("DD-MM-YYYY");
    },
  },
  computed: {
    getIndex() {
      return this.table_data.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    sumField(key) {
      return this.table_data.reduce((a, b) => a + (b[key] || 0), 0);
    },
    search() {
      let range_date = this.time3;
      let province = this.province;
      let isvat = this.isvat == "เสียภาษี" ? true : false;
      let search_obj = {
        MONTH:
          typeof range_date != "object"
            ? null
            : moment(range_date).format("MM"),
        YEAR:
          typeof range_date != "object"
            ? null
            : moment(range_date).format("YYYY"),
        PROVINCE: province,
        TYPE: this.cus_type,
        ISVAT: isvat,
      };
      this.LOADER(true);
      this.$token_api
        .post(`/bill-report`, search_obj)
        .then((res) => {
          let data = res.data.data;
          //console.log(data)
          this.table_data = data;
          this.LOADER(false);
        })
        .catch((err) => {
          console.log(err);
          this.LOADER(false);
        });
    },
    clear() {
      this.time3 = "";
      this.province = "";
      this.cus_type = "";
      this.isvat = "เสียภาษี";
    },
    linktoAnamai() {
      let searh_url = "";
      if (this.table_data.length > 0) {
        let range_date = this.time3;
        let search_obj = {
          MONTH:
            typeof range_date != "object"
              ? null
              : moment(range_date).format("MM"),
          YEAR:
            typeof range_date != "object"
              ? null
              : moment(range_date).format("YYYY"),
          PROVINCE: this.province != "" ? this.province : null,
          TYPE: this.cus_type != "" ? this.cus_type : null,
        };
        for (let key in search_obj) {
          if (search_obj[key]) {
            searh_url += `&${search_obj[key]}`;
          } else {
            searh_url += `&null`;
          }
        }
        console.log(searh_url);
        window.open(`${this.$global_link}/bill-report${searh_url}`, "_blank");
      } else {
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลที่ต้องการส่งออก`,
          timer: 3000,
        });
      }
    },
    export_bill() {
      this.LOADER(true);
      let data = this.getIndex;
      let xls_json = [];
      if (data.length > 0) {
        data.forEach((element) => {
          xls_json.push({
            ลำดับ: element.index,
            ประเภท: element.CUSTOMER_GROUP,
            รหัสใบวางบิล: element.BILL_ID,
            ชื่อลูกค้า: element.CUSTOMER_NAME,
            วันที่: moment(element.WALKOUT_DATE).format("DD-MM-YYYY"),
            "จำนวนน้ำหนัก (กก.)": element.TOTAL_WEIGHT,
            จำนวนเงิน: element.PAID_NO_VAT,
            ภาษีมูลค่าเพิ่ม: element.PAID_VAT,
            "ภาษีหัก ณ ที่จ่าย": element.VAT3,
            ยอดรวมสุทธิ: element.TOTAL_PRICE,
          });
        });
        var wscols = [
          { width: 5 }, // first column
          { width: 20 }, // second column
          { width: 20 }, //...
          { width: 50 },
          { width: 18 },
          { width: 18 },
          { width: 18 },
          { width: 18 },
          { width: 18 },
          { width: 18 },
        ];
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        dataWS["!cols"] = wscols;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(
          wb,
          `รายงานใบวางบิล_${moment().format("DD-MM-YYYY")}.xlsx`
        );
        this.LOADER(false);
      } else {
        this.LOADER(false);
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาเลือกเดือนที่มีข้อมูลรายงาน`,
          timer: 2000,
        });
      }
    },
  },

  mounted() {},
};
</script>